import React from "react";
import { useSeriesEditContext } from "../SeriesEditApp";
import CampaignsTab from "../../ConfirmTicketing/components/CampaignsTab";
import StepFooter from "./StepFooter";

const AutomationsSection = () => {
  const { csrfToken, teamId, form, goToStep } = useSeriesEditContext();
  const description = form.isDraft
    ? "Enable automatic campaigns for this series. Each date starts with these settings, and you can still change them on any date."
    : "Enable automatic campaigns for this series. Changes apply only to dates not created yet; each existing date keeps its own settings.";

  return (
    <div className="series-edit-card">
      <h2 className="series-edit-section-title">Automations</h2>

      {form.venueOwnershipId ? (
        <CampaignsTab
          key={form.venueOwnershipId}
          csrfToken={csrfToken}
          team={{ id: teamId }}
          venueOwnershipId={form.venueOwnershipId}
          overridable={{ type: "EventSeries", id: form.id }}
          description={description}
        />
      ) : (
        <p className="series-edit-hint">Choose a venue in Series Details to see its campaigns.</p>
      )}

      <StepFooter onBack={() => goToStep("tickets")} onNext={() => goToStep("display")} />
    </div>
  );
};

export default AutomationsSection;
